module.exports = __webpack_public_path__ + "media/images/pic/anime/megaphone-3abfee96e325d1116b95a44b0abda0bd.svg";